<template>
  <div id="register">
    <!-- PC端注册 -->
    <div class="pc">
      <my_dialogPc
        v-if="dialogData.flag"
        :myDialogData="dialogData"
        @handleClick="handleClick"
        @focuspassword="focuspassword"
        @inputpassword="inputpassword"
      >
      </my_dialogPc>
    </div>
  </div>
</template>

<script>
import * as RegisterData from "./register.js";
export default {
  data() {
    return {
      flag: 0,
      /* 注册 */
      dialogData: {
        flag: true, //弹出框显隐
        showver: false, //密码修改状态
        // yzm: false, //一开始不显示,当输入手机号时显示发送验证码
        suo: true,
        title: "注册登录信息",
        data: RegisterData.getRegisterDialogData(),
        btns: [
          {
            btnName: "注册",
            active: "logon",
            type: "logon",
          },
        ],
        goBack: {
          active: "registerReturn",
          btnName: "返回",
        },
      },
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
    handleClick(active) {
      let requestData = {};
      switch (active) {
        /* 注册 */
        case "logon":
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            /* 非空判断 */
            if (!element.isNull && element.value == "") {
              this.$message.error(element.name + "不可为空!");
              return;
            }
            if (
              element.key == "phone" &&
              !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(
                element.value
              )
            ) {
              this.$message.error("请填写正确格式的手机号!");
              return;
            }

            if (
              element.key == "idCard" &&
              !this.$idCardValidity.idCardValidity(element.value)
            ) {
              this.$message.error("请填写正确格式的身份证号!");
              return;
            }
            if (element.key == "school") {
              requestData.school = element.value;
            }
            if (element.key == "profession") {
              requestData.profession = element.value;
            }
            if (element.key == "idCard") {
              requestData.idCard = element.value;
            }
            if (element.key == "password") {
              requestData.password = element.value;
            }
            if (element.key == "phone") {
              requestData.phone = element.value;
            }
            // if (element.key == "code") {
            //   requestData.code = element.value;
            // }
          }
          this.$request("post", "/student/logon", requestData, (data) => {
            this.$message({
              showClose: true,
              message: "注册成功!",
              type: "success",
            });
            this.$router.push("/"); //跳转到登录页
          });

          break;
        case "registerReturn":
          this.$router.push("/");
          break;
        default:
          break;
      }
    },

    focuspassword() {
      if (this.dialogData.data[3].value != "") {
        this.$message({
          message: "请再一次确认密码",
          type: "warning",
        });
      }
    },
    inputpassword() {
      if (this.dialogData.data[3].value != this.dialogData.data[4].value) {
        this.$message.error("两次密码不一致,请检查后重新填写!");
        return;
      }
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#register {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .phone {
    width: 100%;
    height: 100%;
  }
  .pc {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);
  }
}
</style>
